import { c as _c } from "react/compiler-runtime";
import type { Locale, StaticTranslationString } from '@/types/types';
import type React from 'react';
const appAdvertisementTextPart1: Record<'map' | 'chat' | 'generic', StaticTranslationString> = {
  map: {
    en: 'This map is part of the',
    de: 'Diese Karte ist Teil der',
    fr: 'Cette carte fait partie de la'
  },
  chat: {
    en: 'This chat is part of the',
    de: 'Dieser Chat ist Teil der',
    fr: 'Cette conversation fait partie de la'
  },
  generic: {
    en: 'This page is part of the',
    de: 'Diese Seite ist Teil der',
    fr: 'Cette page fait partie de la'
  }
};
const appAdvertisementTextPart2: StaticTranslationString = {
  de: 'Lade sie herunter für eine bessere Erfahrung!',
  en: 'Download it for a better experience!',
  fr: 'Téléchargez-la pour une meilleure expérience !'
};
export const AppAdvertisement: React.FC<{
  locale: Locale;
  type?: 'map' | 'chat' | 'generic';
}> = t0 => {
  const $ = _c(5);
  const {
    locale,
    type: t1
  } = t0;
  const type = t1 === undefined ? "generic" : t1;
  const t2 = appAdvertisementTextPart1[type][locale];
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <strong>conveniat27 App</strong>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <br />;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = appAdvertisementTextPart2[locale];
  let t6;
  if ($[2] !== t2 || $[3] !== t5) {
    t6 = <div className="fixed bottom-0 left-(--app-content-left) z-40 flex h-20 w-[calc(100dvw-var(--app-content-left))] items-center justify-center border-t-2 border-gray-200 bg-[#f8fafc] px-4 text-center"><p className="text-sm text-gray-600">{t2} {t3}.{t4}{t5}</p></div>;
    $[2] = t2;
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  return t6;
};